import Vue from 'vue';
import Vuex from 'vuex';

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import devices from "./modules/devices-module";
import projects from "./modules/projects-module";
import typeLines from "./modules/type-lines-module";
import users from "./modules/users-module";
import reports from "./modules/reports-module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        alerts,
        profile,
        devices,
        projects,
        typeLines,
        users,
        reports
    }
});
